import React from 'react';
import { AlertTriangle, Flag } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export const AdminFlagsTab = ({ flags, handleResolveFlag }) => (
  <Card className="border-brand-primary/10">
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <AlertTriangle className="w-5 h-5 text-amber-500" /> Reported Content
      </CardTitle>
    </CardHeader>
    <CardContent>
      {flags.length === 0 ? (
        <div className="text-center py-12">
          <Flag className="w-12 h-12 text-text-muted mx-auto mb-4" />
          <p className="text-text-secondary">No pending reports</p>
        </div>
      ) : (
        <div className="space-y-4">
          {flags.map((flag) => (
            <div key={flag.id} className="flex items-center justify-between p-4 bg-red-50 border border-red-100 rounded-lg" data-testid={`flag-${flag.id}`}>
              <div>
                <Badge className="bg-red-100 text-red-700 mb-2">{flag.content_type}</Badge>
                <p className="text-text-primary">{flag.reason}</p>
                <p className="text-sm text-text-muted mt-1">Reported {new Date(flag.created_at).toLocaleDateString()}</p>
              </div>
              <Button variant="outline" onClick={() => handleResolveFlag(flag.id)} data-testid={`resolve-flag-${flag.id}`}>Resolve</Button>
            </div>
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);
